import { render, staticRenderFns } from "./ToggleButton.vue?vue&type=template&id=728085da&scoped=true"
import script from "./ToggleButton.vue?vue&type=script&lang=ts"
export * from "./ToggleButton.vue?vue&type=script&lang=ts"
import style0 from "./ToggleButton.vue?vue&type=style&index=0&id=728085da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728085da",
  null
  
)

export default component.exports